import { render, staticRenderFns } from "./BedKosongAutoComplete.vue?vue&type=template&id=ea6811aa&"
import script from "./BedKosongAutoComplete.vue?vue&type=script&lang=ts&"
export * from "./BedKosongAutoComplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
